export default __webpack_public_path__ + "static/media/rasam_powder.8f06ef1c.jpg";